import { createReducer } from "@reduxjs/toolkit";
import moment from "moment";
import { postLogTracciatoInfocenterAction, setDataFine, setDataInizio, setPaginaSelezionataAction } from "./actions";
import { LogTracciatoInfocenterReducerType } from "./types";

const initialState: LogTracciatoInfocenterReducerType = {
  logTracciatoInfoCenter: undefined,
  paginaSelezionata: 1,
  dataInizio: moment().subtract('7', 'days').toDate(),
  dataFine: moment().toDate(),
  /*  statoCertificazione: undefined,
   modalitaCertificazione: undefined,
   ndg: undefined, */

}


export const logTracciatoInfocenterReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setDataInizio, (state, action) => {
      state.dataInizio = action.payload;
    })
    .addCase(setDataFine, (state, action) => {
      state.dataFine = action.payload;
    })
    .addCase(postLogTracciatoInfocenterAction.pending, (state) => {
      state.logTracciatoInfoCenter = initialState.logTracciatoInfoCenter
    })
    .addCase(postLogTracciatoInfocenterAction.fulfilled, (state, action) => {
      state.logTracciatoInfoCenter = action.payload;
    })
    .addCase(setPaginaSelezionataAction, (state, action) => {
      state.paginaSelezionata = action.payload
    })

});
